import React, { useMemo, useEffect } from "react";
import { useFormikContext, Field } from "formik";
import styled from "styled-components";
import { Col, Row } from "common/components";
import { Label } from "components/bootstrap";
import { FormikSelect, FormikInput, FormikMarkdownEditor } from "security-app/components/common/FormikComponents";
import { useGetPriorities, useGetStatuses } from "security-app/hooks/useInvestigationsAPI";
import { useUsersAndTeamsOptions } from "../hooks/useUsersAndTeamsOptions";
const DefaultLabel = styled(Label)`
  display: inline-flex;
  margin-left: 5px;
  vertical-align: inherit;
`;
function FormFields() {
  const { values, errors, touched, setFieldValue } = useFormikContext();
  const assignToOptions = useUsersAndTeamsOptions();
  const { priorities } = useGetPriorities();
  const priorityOptions = useMemo(
    () => priorities.map((priority) => ({
      value: priority.priority,
      label: priority.text,
      default: priority.default
    })).sort((a, b) => b.value - a.value),
    [priorities]
  );
  const { statuses } = useGetStatuses();
  const statusOptions = useMemo(
    () => statuses.map((status) => ({
      value: status.status,
      label: status.status,
      default: status.default
    })),
    [statuses]
  );
  useEffect(() => {
    const defaultStatus = statusOptions.find((option) => option.default);
    if (!values.status && defaultStatus) setFieldValue("status", defaultStatus.value);
  }, [setFieldValue, statusOptions, values.status]);
  const renderOption = (option) => /* @__PURE__ */ React.createElement("span", { key: option.value, title: option.value }, option.label, option.default && /* @__PURE__ */ React.createElement(DefaultLabel, { bsStyle: "primary", bsSize: "xsmall" }, "Default"));
  return /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikInput,
      name: "name",
      id: "name",
      type: "text",
      label: "Name *",
      placeholder: "Investigation name",
      value: values.name,
      required: true,
      error: touched.name && errors.name ? errors.name : void 0,
      bsStyle: touched.name && errors.name ? "error" : null
    }
  )), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikSelect,
      name: "assigned_to",
      id: "assigned_to",
      placeholder: "Select user or team",
      label: "Assign to",
      value: values.assigned_to,
      options: assignToOptions,
      maxMenuHeight: 200,
      menuPlacement: "top"
    }
  )), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikSelect,
      name: "priority",
      id: "priority",
      placeholder: "Select priority",
      label: "Priority",
      value: values.priority,
      options: priorityOptions,
      maxMenuHeight: 200,
      menuPlacement: "top",
      optionRenderer: renderOption
    }
  ), /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikSelect,
      name: "status",
      id: "status",
      placeholder: "Select a status",
      label: "Status",
      value: values.status,
      options: statusOptions,
      maxMenuHeight: 200,
      menuPlacement: "top",
      optionRenderer: renderOption
    }
  )), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Field, { id: "notes", name: "notes", component: FormikMarkdownEditor, label: "Notes", height: 150 })));
}
export default FormFields;
